export type JsonLdProps = {
  id: string; // stable + unique per page
  schema: unknown | unknown[]; // single object or array of objects
  /** @deprecated No longer used — JSON-LD is always rendered in the initial HTML. */
  place?: "head" | "body";
};

// Safer stringify: escape </script> tags and HTML comments
function safeStringify(data: unknown) {
  const json = JSON.stringify(data);
  return json?.replace(/<\/script/gi, "<\\/script").replace(/<!--/g, "<\\!--");
}

export default function JsonLd({ id, schema }: JsonLdProps) {
  return (
    <script
      id={id}
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: safeStringify(schema) }}
    />
  );
}
